import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MarkdownRenderer from "components/Markdown/MarkdownRenderer";

export const MidjourneySteps: React.FC = () => {
  const [content, setContent] = useState<string>("");
  const { i18n } = useTranslation();
  const isRtl = i18n.language === "ar";

  useEffect(() => {
    const path = `/docs/${i18n.language}/midjourney-steps_${i18n.language}.md`;

    fetch(path)
      .then((res) => res.text())
      .then(setContent);
  }, [i18n.language]);

  return (
    <div dir={isRtl ? "rtl" : "ltr"} style={{ textAlign: isRtl ? "right" : "left" }}>
      <MarkdownRenderer content={content} />
    </div>
  );
};
